import { eEstadoMaestro } from "../common/enumModel";
import { IGbuModel } from "../interfaces/gbus/IGbuModel";

export class GbuModel implements IGbuModel {
    
    idGbu : number;
    nombre : string;
    idEstado: eEstadoMaestro;
    estado: string;
    
    constructor(){
        this.idGbu = 0;
        this.nombre = '';
        this.idEstado = eEstadoMaestro.ACTIVO;
        this.estado = '';
    }
}